export default __webpack_public_path__ + "static/media/Substrates.cb85c513.svg";